import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDassaultsystemesComponent } from './simple-icons-dassaultsystemes.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDassaultsystemesComponent ],
    exports:      [ SimpleIconsDassaultsystemesComponent ],
    bootstrap:    []
})
export class SimpleIconsDassaultsystemesModule {}
